import CaptionEdit from './CaptionEdit';
export default CaptionEdit;
//# sourceMappingURL=index.js.mapimport CaptionEdit from './CaptionEdit';
export default CaptionEdit;
//# sourceMappingURL=index.js.map